module.exports = __webpack_public_path__ + "img/7.86d97fc5.png";